<template>
   <div>
      <div class="form-group _margin-bottom-30">
         <div class="col-xs-12 _margin-bottom-20">
            <form-label id="switchAfterCoolingOfPeriod">Faster Switching</form-label>
            <p class="_margin-top-0 _margin-bottom-0">I understand that the switch to {{ switchPlan.supplierName }} will
               go ahead as soon as possible. Should I change my mind within the 14 day cooling off period I can do so
               without incurring any early exit fees and I agree to pay for the energy used whilst on supply with
               {{ switchPlan.supplierName }}
            </p>
            <p class="_margin-bottom-0">Your application will be sent to So Energy, who will get in touch to confirm
               your
               details. So Energy will switch you over in approximately 5 working days and will contact you if any
               further details are required. So Energy will send your Welcome Pack by email which will contain your
               confirmation of contact, tariff information and terms and conditions. So Energy will perform a credit
               check and could ask you to agree to additional conditions before the switch is completed, all of which
               will be communicated to you before you complete signing up.</p>
         </div>
      </div>
      <div class="form-group _margin-bottom-20" v-show="switchPlan.payMethod == 'PrePaymentMeter'">
         <div class="col-sm-8">
            <form-label id="prePaymentMeter">Pre Payment Meter Type</form-label>
            <validation-messages label="Pre Payment Meter Type" :$v="v.prePaymentMeterId">
               <select-list id="prePaymentMeter" v-model="terms.prePaymentMeterId" value-key="id" :list="prepaymentList"
                  :error="v.prePaymentMeterId.$error" />
            </validation-messages>
         </div>
      </div>

      <div class="form-group _margin-bottom-20">
         <div class="col-md-10">
            <form-label id="supplierProductServices">
               Can {{ switchPlan.supplierName }} keep in touch with you about their other products and services?
            </form-label>
            <div>
               <radio :value="true" id="supplierProductServices_yes" inline style="margin-right: 10px;"
                  v-model="terms.supplierMaySendRemindersAndUpdatesViaEmailAboutAccount">
                  Yes
               </radio>
               <radio :value="false" inline id="supplierProductServices_no"
                  v-model="terms.supplierMaySendRemindersAndUpdatesViaEmailAboutAccount">
                  No
               </radio>
            </div>
         </div>
      </div>

      <div class="form-group _margin-bottom-20">
         <div class="col-sm-12">
            <checkbox id="hasMedicalCondition" v-model="terms.hasMedicalConditionOrIndividualRequirement"
               @change="onChangeSpecialNeeds">
               I have a particular medical condition or individual requirement.<br />
               <small v-if="terms.hasMedicalConditionOrIndividualRequirement">Any information provided will be passed
                  onto your new Supplier, who may subsequently request further information from you.</small>
            </checkbox>
         </div>
      </div>

      <div class="form-group _margin-bottom-20">
         <div class="col-md-10">
            <validation-messages label="Terms & Conditions Agreement" :$v="v.suppliersTermsAndConditionsAreAccepted">
               <checkbox id="termsAndConditions" v-model="terms.suppliersTermsAndConditionsAreAccepted"
                  :error="v.suppliersTermsAndConditionsAreAccepted.$error"
                  @change="terms.suppliersTermsAndConditionsAreAccepted = terms.suppliersTermsAndConditionsAreAccepted ? true : null">
                  Yes, I accept the energy supplier
                  <a target="_blank" :href="switchPlan.supplierTosUrl">terms and conditions</a>
               </checkbox>
            </validation-messages>
         </div>
      </div>
   </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
   name: 'Default',
   props: {
      v: Object
   },
   mounted() {
      this.terms.switchAfterCoolingOfPeriod = false;
   },
   computed: {
      ...mapState({
         switchPlan: ({ personal_details_switch_plan }) => personal_details_switch_plan,
         terms: ({ personal_details_terms }) => personal_details_terms,
         specialNeedsList: ({ lookups }) => lookups.specialNeeds,
         prepaymentList: ({ lookups }) => lookups.prepayments
      })
   },
   methods: {
      async onChangeSpecialNeeds() {
         if (this.terms.hasMedicalConditionOrIndividualRequirement) {
            await this.$store.dispatch('lookups/getSpecialNeedsList');
            this.terms.specialNeedsId = this.specialNeedsList[0].id;
         } else {
            this.terms.specialNeedsId = null;
         }
      },
      onChangeSmartMeterInstalled() {
         if (this.terms.gasSmartMeterInstalled || this.terms.electricitySmartMeterInstalled) {
            this.terms.agreeSmartMeterConditions = null;
            this.terms.neitherSmartMeterInstalled = false;
         } else {
            this.terms.agreeSmartMeterConditions = false;
            this.terms.neitherSmartMeterInstalled = null;
         }
      },
      onChangeNeitherInstalled(value) {
         this.terms.neitherSmartMeterInstalled = value || null;
         this.terms.gasSmartMeterInstalled = false;
         this.terms.electricitySmartMeterInstalled = false;
         this.terms.agreeSmartMeterConditions = false;
      }
   }
};
</script>

<style lang="scss"></style>
